import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';

@Component({
  selector: 'app-project-wise-summary',
  templateUrl: './project-wise-summary.component.html',
  styleUrls: ['./project-wise-summary.component.css']
})
export class ProjectWiseSummaryComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService, private _exportService: ExportService) { }

  formTitle = "Project Wise Subtask Detailed Summary";
  loadprojectexcel: boolean = false;

  ngOnInit(): void {
    this.loadAllProjects();
  }

  projectID = null;
  projectList = [];

  loadAllProjects() {
    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', ' and IS_ACTIVE=1').subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.projectList = projectData['data'];
      }

    }, err => {

    });
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["PROJECT", "Project"], ["MODULE", "Module"], ["FEATURE", "Feature"], ["TASK", "Task"], ["SUBTASK", "Subtask"]];
  filterQuery: string = "";
  isProjectSpinning = false;
  loadingRecords = false;
  projectData = [];
  date = new Date();

  getProjectWiseSummary(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";

    } catch (error) {
      sort = "";
    }



    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }

    this.applyFilter();

    var filter = ""
    if (likeQuery)
      // filter = this.filterQuery + likeQuery;
      filter = this.filterQuery;
    else
      filter = this.filterQuery;

    this._apiService.getProjectWiseSummary(this.pageIndex, this.pageSize, this.sortKey, sort, '', this.projectID, this.searchText).subscribe(data => {
      this.loadingRecords = false;
      this.isProjectSpinning = false;
      this.totalRecords = data['count'];
      this.projectData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";
  PROJECT_DATE = null;

  applyFilter() {
    this.filterQuery = "";

    if (this.projectID == null) {
      this.isFilterApplied = "default";
    }
    else {
      this.isFilterApplied = "primary";
    }

    this.filterClass = "filter-invisible";
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";
    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";
    this.projectID = null;
    this.PROJECT_DATE = null;

    this.getProjectWiseSummary(true);
  }

  sortKey: string = "id";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    // if (currentSort != null && currentSort.value != undefined) {
    this.getProjectWiseSummary();
    // }
  }

  importInExcel() {

    var arry1 = [];
    var arry2 = [];

    var obj1: any = new Object();
    var obj2: any = new Object();

    for (var i = 0; i < this.projectData.length; i++) {
      obj1['Start Date'] = this.datePipe.transform(this.projectData[i]['START_DATE'], 'dd MMM, yyyy');
      obj1['Project'] = this.projectData[i]['PROJECT'];
      obj1['Module'] = this.projectData[i]['MODULE'];
      obj1['Feature'] = this.projectData[i]['FEATURE'];
      obj1['Task'] = this.projectData[i]['TASK'];
      obj1['Subtask'] = this.projectData[i]['SUBTASK'];
      obj1['Total Time'] = this._apiService.convertIntoHMS(Number(this.projectData[i]['SUBTASK_TOTAL_SECONDS']));
      arry1.push(Object.assign({}, obj1));

      obj2['Start Date'] = this.datePipe.transform(this.projectData[i]['START_DATE'], 'dd MMM, yyyy');
      obj2['Project'] = this.projectData[i]['PROJECT'];
      obj2['Module'] = this.projectData[i]['MODULE'];
      obj2['Feature'] = this.projectData[i]['FEATURE'];
      obj2['Task'] = this.projectData[i]['TASK'];
      obj2['Subtask'] = this.projectData[i]['SUBTASK'];
      obj2['Total Seconds'] = this.projectData[i]['SUBTASK_TOTAL_SECONDS'];
      arry2.push(Object.assign({}, obj2));

      if (i == this.projectData.length - 1) {
        this._exportService.exportExcel(arry1, 'Project Wise Subtask Detailed Summary Report (HH:MM:SS)');
        this._exportService.exportExcel(arry2, 'Project Wise Subtask Detailed Summary Report (In Seconds)');
      }
    }
  }
}
